import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=5b58b8f8&scoped=true"
import script from "./courseDetail.vue?vue&type=script&lang=js"
export * from "./courseDetail.vue?vue&type=script&lang=js"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=5b58b8f8&prod&lang=less"
import style1 from "./courseDetail.vue?vue&type=style&index=1&id=5b58b8f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b58b8f8",
  null
  
)

export default component.exports